import { type DirectorData } from "services/director/directorTypes";
import { type DirectorPositionStore, isShareholder } from "services/directorPosition/directorPositionStore";

/**
 * The shareholders among a set of directors: the main director is always treated as a shareholder,
 * anyone else only if their stored position is a shareholder role. Falls back to the full list when
 * position info has not loaded yet. This is the single source of truth shared by the shares UI
 * (`useShareholders`) and the submit-side PSC logic (`ParticularsStepStore.updateShares`) so the two
 * can never disagree on whether a company has a sole shareholder.
 */
export const getShareholders = (
  directors: DirectorData[],
  mainDirectorId: string | undefined,
  directorPositionsStore: DirectorPositionStore,
): DirectorData[] => {
  if (!directorPositionsStore.hasInfo) {
    return directors;
  }

  return directors.filter((director) => {
    if (director.id === mainDirectorId) {
      return true;
    }

    return isShareholder(directorPositionsStore.getForDirector(director.id));
  });
};
